import React from 'react';
import E9Form from './E9Form';
import E9QRCode from './E9QRCode';

class E9Login extends React.Component {
    constructor(props) {
        super(props);   
    }
    render() {
        const { loading,  loginstate}=this.props;
        const {
            loginSettingInfo = {},
            loginType,
            langId,
            labelInfo,
            openAgreement
        } = loginstate;
        const { loginInfo } = loginSettingInfo;
        if(loginInfo!=undefined){
            const { showQrcode, onlyQrcode } = loginInfo;
            let labelObj=labelInfo[`langid${langId}`] || {};
            return (
            <div id="LoginPopContainer" className="e9login-pop-container" onClick={() => {this.props.loginsetState({ multiLangVisible: false})}}>
                <div className="e9login-pop-content">
                    {!loading && <React.Fragment >
                        {
                            showQrcode && !onlyQrcode ? (
                                <div className="e9login-pop-qrcode e9login-pop-element">
                                    {loginType == 'form' ? <i className="icon-coms-Scan" title={labelObj.smdl} 
                                    onClick={(e) => {
                                        e.preventDefault && e.preventDefault();
                                        e.stopPropagation && e.stopPropagation();
                                        this.props.setStateAndCache('loginType', 'QRCode')}} 
                                    /> : <i className="icon-coms-Revoke2" title={labelObj.fh} 
                                    onClick={(e) => { 
                                        e.preventDefault && e.preventDefault();
                                        e.stopPropagation && e.stopPropagation();
                                        this.props.setStateAndCache('loginType', 'form')}}
                                    />}
                                </div>
                            ) : ''
                        }
                        <div className="e9login-pop-form-box e9login-pop-element">
                            {loginType == 'form' ? <E9Form  {...this.props} /> : <E9QRCode  {...this.props}/>}
                        </div>
                        <div className='e9login-pop-form-message' style={openAgreement==1 ? {marginTop:'5px'} : {}}>
                            {labelObj.popmessage}
                        </div>
                    </React.Fragment>}
                </div>
            </div>
        );
        }else{
            return <div/>
        }
        
    }
}

export default E9Login;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/components/wea-login-pop/e9login/E9Login.js